import { v7 } from "uuid";

export const NIL_UUID = "00000000-0000-0000-0000-000000000000";

export const createId = () => v7();

export const createIds = (count: number) => Array.from({ length: count }, createId);
